import React from 'react';

function Projects({ language }) {
  const t = (en, id) => language === 'en' ? en : id;

  return (
    <div className="projects-page">
      <div className="projects-header">
        <h1>{t('Our Projects & References', 'DAFTAR REFERENSI')}</h1>
        <p>
          {t('List of companies, apartments, and residences built or modified using PT. Esawarna Gemilang products and services',
             'Daftar Perusahaan, Apartment, Perumahan yang dibuat, Dimodifikasi dengan menggunakan Product dan Jasa PT. Esawarna Gemilang')}
        </p>
      </div>

      {/* Section I */}
      <section className="project-section">
        <h2>I. {t('Swimming Pool Construction & Equipment Installation', 'Pembuatan & Pasang Peralatan Swimming Pool')}</h2>
        <div className="table-container">
          <table className="reference-table">
            <thead>
              <tr>
                <th>No</th>
                <th>{t('Company / Client Name', 'Nama Perusahaan / Klien')}</th>
                <th>Volume</th>
                <th>{t('Contact Person', 'Contact Person')}</th>
                <th>{t('Location', 'Lokasi')}</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>Pemda Bantaeng</td><td>2500 m³</td><td>Zaenal</td><td>Makasar</td></tr>
              <tr><td>2</td><td>Pemda Bantaeng</td><td>250 m³</td><td>Zaenal</td><td>Makasar</td></tr>
              <tr><td>3</td><td>Hj.R.Ajeng Ratna Suminar, SH</td><td>366 m³</td><td>Ajeng</td><td>Jatinangor</td></tr>
              <tr><td>4</td><td>Ir.B .Aan Indiarto</td><td>80 m³</td><td>Aan</td><td>Bandung</td></tr>
              <tr><td>5</td><td>Bambang</td><td>65 m³</td><td>Bambang</td><td>Bandung</td></tr>
              <tr><td>6</td><td>Anisa</td><td>75 m³</td><td>Anisa</td><td>Jatinangor</td></tr>
              <tr><td>7</td><td>Netty</td><td>40 m³</td><td>Netty</td><td>Bandung</td></tr>
              <tr><td>8</td><td>Hotel Ahadiat</td><td>80 m³</td><td>Solehudin</td><td>Bandung</td></tr>
              <tr><td>9</td><td>Rachman Yusuf</td><td>50 m³</td><td>Rachman Yusuf</td><td>Bandung</td></tr>
              <tr><td>10</td><td>Harry</td><td>60 m³</td><td>Harry</td><td>Ciranjang</td></tr>
              <tr><td>11</td><td>Hamid</td><td>40 m³</td><td>Hamid</td><td>Bandung</td></tr>
              <tr><td>12</td><td>Dr.Gumar</td><td>37 m³</td><td>Dr.Gumar</td><td>Bandung</td></tr>
              <tr><td>13</td><td>Deddy</td><td>75 m³</td><td>Deddy</td><td>Cipatat</td></tr>
              <tr><td>14</td><td>Hotel Horison Butik</td><td>90 m³</td><td>H. Nana. H</td><td>Bandung</td></tr>
              <tr><td>15</td><td>Danny Lukita</td><td>150 m³</td><td>Danny Lukita</td><td>Bandung</td></tr>
              <tr><td>16</td><td>Ming Cun</td><td>47 m³</td><td>Ming Cun</td><td>Bandung</td></tr>
              <tr><td>17</td><td>Treenity Villa</td><td>60 m³</td><td>Ir. Gunawan</td><td>Bandung</td></tr>
              <tr><td>18</td><td>Yunita SH</td><td>200 m³</td><td>Yunita SH</td><td>Bandung</td></tr>
              <tr><td>19</td><td>PT. Andri Mitra</td><td>150 m³</td><td>Harumia</td><td>Bandung</td></tr>
              <tr><td>20</td><td>Rachmad</td><td>350 m³</td><td>Rachmad</td><td>Sentul, Jkt</td></tr>
              <tr><td>21</td><td>Dr. Alif</td><td>60 m³</td><td>Dr. Alif</td><td>Ciranjang</td></tr>
              <tr><td>22</td><td>Mr. Shao</td><td>20 m³</td><td>Mr. Shao</td><td>Bandung</td></tr>
              <tr><td>23</td><td>Pandai</td><td>150 m³</td><td>Pandai</td><td>Bandung</td></tr>
              <tr><td>24</td><td>Pandan Wangi</td><td>250 m³</td><td>Yukang</td><td>Bandung</td></tr>
              <tr><td>25</td><td>Grande Valore Cikarang</td><td>250 m³</td><td>Suryana D</td><td>Cikarang</td></tr>
              <tr><td>26</td><td>Kolam Rumah Tinggal Dr. Teddy</td><td>80 m³</td><td>Pak Hengky Susanto</td><td>Rancabentang</td></tr>
              <tr><td>27</td><td>Kolam Rumah De Maja E19/7</td><td>42 m³</td><td>Bpk. Ir. Tommy</td><td>Tangerang</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Section II */}
      <section className="project-section">
        <h2>II. {t('Swimming Pool Renovation', 'Renovasi Swimming Pool')}</h2>
        <div className="table-container">
          <table className="reference-table">
            <thead>
              <tr>
                <th>No</th>
                <th>{t('Company / Client Name', 'Nama Perusahaan / Klien')}</th>
                <th>Volume</th>
                <th>{t('Contact Person', 'Contact Person')}</th>
                <th>{t('Location', 'Lokasi')}</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>Oppy</td><td>200 m³</td><td>Oppy</td><td>Bandung</td></tr>
              <tr><td>2</td><td>Grand Seriti Hotel</td><td>350 m³</td><td>Rizky</td><td>Bandung</td></tr>
              <tr><td>3</td><td>The Kartipah</td><td>225 m³</td><td>Abung</td><td>Bandung</td></tr>
              <tr><td>4</td><td>Hotel Vue Palace</td><td>200 m³</td><td>Budi</td><td>Bandung</td></tr>
              <tr><td>5</td><td>Giri Gahana Golf & S. Pool</td><td>350 m³</td><td>Agus</td><td>Bandung</td></tr>
              <tr><td>6</td><td>Grand Pasundan Hotel</td><td>375 m³</td><td>Nanan Gunawan</td><td>Bandung</td></tr>
              <tr><td>7</td><td>Green Apple Puncak</td><td>900 m³</td><td>Ir. Robert</td><td>Bandung</td></tr>
              <tr><td>8</td><td>Hotel Padma</td><td>350 m³</td><td>Mahisa Tantra</td><td>Bandung</td></tr>
              <tr><td>9</td><td>Rumah tinggal Bapak Yukang</td><td>100 m³</td><td>Bapak Yukang</td><td>Bandung</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Section III */}
      <section className="project-section">
        <h2>III. {t('Swimming Pool Maintenance', 'Maintenance Swimming Pool')}</h2>
        <div className="table-container">
          <table className="reference-table">
            <thead>
              <tr>
                <th>No</th>
                <th>{t('Company / Client Name', 'Nama Perusahaan / Klien')}</th>
                <th>Volume</th>
                <th>{t('Contact Person', 'Contact Person')}</th>
                <th>{t('Location', 'Lokasi')}</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>Bandung International School</td><td>350 m³</td><td>Suwardi</td><td>Bandung</td></tr>
              <tr><td>2</td><td>Hotel Prama Grand Preanger</td><td>250 m³</td><td>Yahya Nurudin</td><td>Bandung</td></tr>
              <tr><td>3</td><td>Graha Cempaka Mas</td><td>250 m³</td><td>Sondang</td><td>Jakarta</td></tr>
              <tr><td>4</td><td>ITC Poxy Mas</td><td>800 m³</td><td>Hartono</td><td>Jakarta</td></tr>
              <tr><td>5</td><td>PT.Saranapapan Ekasejati</td><td>800 m³</td><td>Frans. H</td><td>Jakarta</td></tr>
              <tr><td>6</td><td>PT. Maligi Permata</td><td>3000 m³</td><td>Anwar . S</td><td>Jakarta</td></tr>
              <tr><td>7</td><td>Hotel Holiday Inn</td><td>200 m³</td><td>Tutang Chaerudin</td><td>Bandung</td></tr>
              <tr><td>8</td><td>Hotel Novus Puncak</td><td>350 m³</td><td>Resmiyadi</td><td>Puncak</td></tr>
              <tr><td>9</td><td>Hotel Courtyard Marriot Dago</td><td>250 m³</td><td>Deddy William</td><td>Bandung</td></tr>
              <tr><td>10</td><td>Grand Pasundan Hotel</td><td>375 m³</td><td>Yoyo Yohana</td><td>Bandung</td></tr>
              <tr><td>11</td><td>Apartment Majesty</td><td>200 m³</td><td>Ateng Wahyudi</td><td>Bandung</td></tr>
              <tr><td>12</td><td>Apartment Setiabudi</td><td>200 m³</td><td>Aris Herman</td><td>Bandung</td></tr>
              <tr><td>13</td><td>Apartment Ciumbuleuit 1</td><td>250 m³</td><td>Yudi Kusuma</td><td>Bandung</td></tr>
              <tr><td>14</td><td>Apartment Ciumbuleuit 2</td><td>300 m³</td><td>Hamdani</td><td>Bandung</td></tr>
              <tr><td>15</td><td>Ocean Park Jakarta</td><td>14000 m³</td><td>Hartono</td><td>BSD</td></tr>
              <tr><td>16</td><td>Rumah tinggal Mr Ming Cun</td><td>40 m³</td><td>Ming Cun</td><td>Bandung</td></tr>
              <tr><td>17</td><td>Rumah tinggal Ibu Carren</td><td>100 m³</td><td>Carren</td><td>Bandung</td></tr>
              <tr><td>18</td><td>Rumah tinggal Ibu Lili</td><td>40 m³</td><td>Yos</td><td>Bandung</td></tr>
              <tr><td>19</td><td>Rumah tinggal Bp Rachman Yusuf</td><td>50 m³</td><td>Rachman Yusuf</td><td>Bandung</td></tr>
              <tr><td>20</td><td>Rumah tinggal Bp Dani</td><td>50 m³</td><td>Dani</td><td>Bandung</td></tr>
              <tr><td>21</td><td>Rumah tinggal Ibu Angella</td><td>40 m³</td><td>Angella</td><td>Bandung</td></tr>
              <tr><td>22</td><td>Golden Flower Hotel</td><td>100 m³</td><td>Tatang Kurnia</td><td>Bandung</td></tr>
              <tr><td>23</td><td>Rumah tinggal Ibu Liontine</td><td>80 m³</td><td>Liontine</td><td>Bandung</td></tr>
              <tr><td>24</td><td>Rumah tinggal Ibu Sesi</td><td>60 m³</td><td>Sesi</td><td>Bandung</td></tr>
              <tr><td>25</td><td>Rumah tinggal Mr.Simon Lamplug</td><td>50 m³</td><td>Simon Lamplug</td><td>Bandung</td></tr>
              <tr><td>26</td><td>Hotel Luxton</td><td>150 m³</td><td>Yosep Hendroyo</td><td>Bandung</td></tr>
              <tr><td>27</td><td>The Trans Luxury Hotel</td><td>400 m³</td><td>Ir. Leonardus P</td><td>Bandung</td></tr>
              <tr><td>28</td><td>Aston Primera Pasteur</td><td>200 m³</td><td>Arief Djaenuri</td><td>Bandung</td></tr>
              <tr><td>29</td><td>Hotel Mitra</td><td>200 m³</td><td>Waridi</td><td>Bandung</td></tr>
              <tr><td>30</td><td>Pine Wood Hotel</td><td>250 m³</td><td>Agus</td><td>Bandung</td></tr>
              <tr><td>31</td><td>PT. Bikasoga</td><td>400 m³</td><td>Fitra Jaya</td><td>Bandung</td></tr>
              <tr><td>32</td><td>Hotel Green Forest</td><td>80 m³</td><td>Rully</td><td>Bandung</td></tr>
              <tr><td>33</td><td>Gateway apartement</td><td>300 m³</td><td>Deddy. D</td><td>Bandung</td></tr>
              <tr><td>34</td><td>The Edge Apartment</td><td>150 m³</td><td>Budi Prasetya</td><td>Bandung</td></tr>
              <tr><td>35</td><td>Hotel Universal</td><td>400 m³</td><td>Mamad Ruhiyat</td><td>Bandung</td></tr>
              <tr><td>36</td><td>Hotel Clarity</td><td>150 m³</td><td>Andri. S</td><td>Bandung</td></tr>
              <tr><td>37</td><td>Istana Sudirman</td><td>60 m³</td><td>Deni Irawan</td><td>Bandung</td></tr>
              <tr><td>38</td><td>Crowne Plaza Bandung</td><td>250 m³</td><td>Jimmy Oktavian</td><td>Bandung</td></tr>
              <tr><td>39</td><td>Apartement Sudirman Suite</td><td>300 m³</td><td>Darma</td><td>Bandung</td></tr>
              <tr><td>40</td><td>Best Western Premier La Grande Hotel</td><td>200 m³</td><td>Andrik Abadi.K</td><td>Bandung</td></tr>
              <tr><td>41</td><td>Rumah tinggal Bp Harry</td><td>60 m³</td><td>Harry</td><td>Bandung</td></tr>
              <tr><td>42</td><td>Hotel Santika</td><td>150 m³</td><td>Casriko</td><td>Bandung</td></tr>
              <tr><td>43</td><td>Rumah tinggal Bp Yahya Santosa</td><td>100 m³</td><td>Jimmy</td><td>Bandung</td></tr>
              <tr><td>44</td><td>Hotel Savali Padang</td><td>300 m³</td><td>Sito</td><td>Bandung</td></tr>
              <tr><td>45</td><td>Hotel Park</td><td>150 m³</td><td>Doni</td><td>Bandung</td></tr>
              <tr><td>46</td><td>Hotel Park View</td><td>150 m³</td><td>Amin</td><td>Bandung</td></tr>
              <tr><td>47</td><td>Rumah tinggal Bp Yukang</td><td>80 m³</td><td>Yukang</td><td>Bandung</td></tr>
              <tr><td>48</td><td>Rumah tinggal Bp Ricky</td><td>60 m³</td><td>Ricky</td><td>Bandung</td></tr>
              <tr><td>49</td><td>Rumah tinggal Ibu Elis</td><td>50 m³</td><td>Elis</td><td>Bandung</td></tr>
              <tr><td>50</td><td>Hotel Amaris Cimanuk</td><td>60 m³</td><td>Nanang</td><td>Bandung</td></tr>
              <tr><td>51</td><td>Hotel Grandia</td><td>150 m³</td><td>Chandra Hermawan</td><td>Bandung</td></tr>
              <tr><td>52</td><td>Hotel Four point</td><td>60 m³</td><td>Asep Setiawan</td><td>Bandung</td></tr>
              <tr><td>53</td><td>Hotel Paviljoen</td><td>200 m³</td><td>Yadi Supriyadi</td><td>Bandung</td></tr>
              <tr><td>54</td><td>Landmark Residence</td><td>1000 m³</td><td>Rizki Fajar</td><td>Bandung</td></tr>
              <tr><td>55</td><td>Rumah tinggal Ibu Liely</td><td>100 m³</td><td>Ibu Lili</td><td>Bandung</td></tr>
              <tr><td>56</td><td>Gaia Hotel Bandung</td><td>216 m³</td><td>Taufik</td><td>Bandung</td></tr>
              <tr><td>57</td><td>Rumah Tinggal Bapak Rudi</td><td>72 m³</td><td>Rudi</td><td>KB Parahyangan</td></tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default Projects;